import React from 'react';
import {
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Progress
} from 'reactstrap';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from '../../../components/Form/Select';
import SelectUserAsync from '../../../components/Form/Select/Async/SelectUser';
import Radio from '../../../components/Form/Radios/Radio';
import InputDatetime from '../../../components/Form/InputDatetime/InputDatetime';
import { hasError, errorMessage, textChange, textValue, dateValue, dateChange, checkChange } from '../../../utils/form';
import { isEmail } from '../../../helpers/regex';
import { apiClient } from '../../../utils/Api';

// Style constants extracted to avoid inline objects in JSX (CLAUDE.md line 76)
const CSV_BTN_STYLE = { background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginLeft: 8 };
const HIDDEN_INPUT_STYLE = { display: 'none' };
const WARNING_TEXT_STYLE = { color: '#856404' };
const DUPLICATES_BOX_STYLE = { backgroundColor: '#fff3cd', padding: '8px', borderRadius: '4px', maxHeight: '100px', overflowY: 'auto' };
const SCROLLABLE_LIST_STYLE = { maxHeight: '150px', overflowY: 'auto' };
const SMALL_TEXT_STYLE = { fontSize: '12px' };

// Constants
const CSV_MAX_EMAILS = 200;

export class ModalUserVoucher extends React.Component{
  constructor(props){
    super(props);
    moment.tz.setDefault("Asia/Jakarta");
    this._isMounted = false;
    this._csvValidationId = 0;
    this.csvInputRef = React.createRef();
    this.successMessageTimer = null;
    this.state={
      id:null,
      user:[],
      voucher_id:null,
      used:false,
      used_count:0,
      used_at:null,
      started_at:null,
      ended_at:null,
      quantity:1,
      isSubmit:false,
      isAletError:false,
      error:null,
      // CSV upload state
      csvParsing: false,
      csvValidating: false,
      csvValidationProgress: { current: 0, total: 0 },
      csvValidationResults: null,
      showCsvResults: false,
      csvError: null,
      csvSuccessMessage: null
    }
    this.handleCheckedChange=this.handleCheckedChange.bind(this);
    this._handleOnSelectUserChange = this._handleOnSelectUserChange.bind(this);
    this._handleOnSelectUserOpen = this._handleOnSelectUserOpen.bind(this);
    this.handleChange=this.handleChange.bind(this);
    this.onSubmit=this.onSubmit.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    // CSV methods binding
    this._triggerCsvInput = this._triggerCsvInput.bind(this);
    this._handleCsvFileChange = this._handleCsvFileChange.bind(this);
    this._parseAndValidateCsv = this._parseAndValidateCsv.bind(this);
    this._confirmAddValidUsers = this._confirmAddValidUsers.bind(this);
    this._clearCsvResults = this._clearCsvResults.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.successMessageTimer) {
      clearTimeout(this.successMessageTimer);
    }
  }

  _handleOnSelectUserChange(selected){
    let { user } = this.state;
    user = selected;
    this.setState({
      user,
      _recentUserSearch: selected && this.state._recentUserSearch
    })
  }

  _handleOnSelectUserOpen(){
    if(this.state.user){
      return this.state._recentUserSearch&&this.refs.selectUser.loadSelectOptions(this.state._recentUserSearch);
    }
    return this.refs.selectUser.loadSelectOptions('');
  }

  handleChange(e){
    this.setState(textChange(e,{...this.state}));
  }

  handleDatePickerChange(date, name){
    this.setState(dateChange(date,name, {...this.state}));
  }

  handleCheckedChange(e){
    const _form=checkChange(e,this.state);
    this.setState({..._form});
  }
  componentWillReceiveProps(nextProps){
    const { dataUserVouchers, userVoucherSelected } = nextProps;
    if(nextProps.isOpen===true&&nextProps.isOpen!==this.props.isOpen){
      if(userVoucherSelected==null) {
        this.setState({
          voucher_id:nextProps.voucherId,
          error: null
        });
      }
      else{
        this.setState({
          id:userVoucherSelected.id,
          used:userVoucherSelected.used,
          used_count:userVoucherSelected.used_count,
          used_at:userVoucherSelected.used_at,
          voucher_id:nextProps.voucherId,
          started_at:userVoucherSelected.started_at,
          ended_at:userVoucherSelected.ended_at,
          user:userVoucherSelected.user && { id: userVoucherSelected.user.id, email: userVoucherSelected.user.email },
          error: null
        });
      }
    }
    else if(nextProps.isOpen===false&&nextProps.isOpen!==this.props.isOpen) {
      // Invalidate any in-flight CSV validation
      this._csvValidationId++;
      this.setState({
        id:null,
        user:[],
        isSubmit:false,
        used:false,
        used_count:0,
        used_at:null,
        started_at:null,
        ended_at:null,
        quantity:1,
        // Reset CSV state on modal close
        csvParsing: false,
        csvValidating: false,
        csvValidationProgress: { current: 0, total: 0 },
        csvValidationResults: null,
        showCsvResults: false,
        csvError: null,
        csvSuccessMessage: null
      },()=>this.props.onRemoveSelected());
    }
    if(dataUserVouchers.isSubmit!==this.props.dataUserVouchers.isSubmit
      &&dataUserVouchers.isSubmit===false){
        const { error, isDelete } = dataUserVouchers;
        if(error)
          this.setState({
            error:{...dataUserVouchers.error},
            isSubmit:false, isAlertError:true},
          );
        else if(!isDelete){
          this.setState({
            isSubmit:false,
            started_at:null,
            ended_at:null,
            quantity:1,
          },()=>{this.props.onCancel()});
          this.props.onGetUserVoucherList();
        }
    }
  }

  onDismiss() {
    this.setState({
      isAlertError: false,
      error: null
    }, ()=>{this.props.onRemoveSelected()});
  }

  // CSV Upload Methods
  _triggerCsvInput() {
    if (this.csvInputRef.current) {
      this.csvInputRef.current.value = '';
      this.csvInputRef.current.click();
    }
  }

  _handleCsvFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    // Validate .csv extension
    const extension = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
    if (extension !== '.csv') {
      if (this._isMounted) {
        // Clear stale results when rejecting invalid file
        this.setState({
          csvError: 'Please upload a .csv file',
          csvValidationResults: null,
          showCsvResults: false,
          csvSuccessMessage: null
        });
      }
      return;
    }

    this._parseAndValidateCsv(file);
  }

  _readFileAsText(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (e) => reject(e);
      reader.readAsText(file);
    });
  }

  async _parseAndValidateCsv(file) {
    // Increment validation ID to invalidate any previous in-flight validation
    this._csvValidationId++;
    const currentValidationId = this._csvValidationId;

    // Helper to check if this validation is still current
    const isValidationStale = () => this._csvValidationId !== currentValidationId;

    // Clear any previous results/errors when starting new upload
    this.setState({
      csvParsing: true,
      csvError: null,
      csvSuccessMessage: null,
      csvValidationResults: null,
      showCsvResults: false
    });

    try {
      const content = await this._readFileAsText(file);
      if (isValidationStale()) return;

      const lines = content.split(/\r?\n/).map(line => line.trim()).filter(line => line);

      // Check max emails limit
      if (lines.length > CSV_MAX_EMAILS) {
        if (this._isMounted && !isValidationStale()) {
          this.setState({ csvParsing: false, csvError: `File exceeds maximum of ${CSV_MAX_EMAILS} emails` });
        }
        return;
      }

      // Check for commas in any line (invalid format)
      const hasComma = lines.some(line => line.includes(','));
      if (hasComma) {
        if (this._isMounted && !isValidationStale()) {
          this.setState({ csvParsing: false, csvError: 'Invalid file format - ensure one email per line with no commas' });
        }
        return;
      }

      // Validate email format and collect unique emails
      const validFormatEmails = [];
      const invalidFormatEmails = [];

      lines.forEach(email => {
        const trimmedEmail = email.toLowerCase();
        if (isEmail(trimmedEmail)) {
          if (!validFormatEmails.includes(trimmedEmail)) {
            validFormatEmails.push(trimmedEmail);
          }
        } else {
          invalidFormatEmails.push({ email, reason: 'Invalid email format' });
        }
      });

      // Early return if no valid emails to validate against API
      if (validFormatEmails.length === 0) {
        if (this._isMounted && !isValidationStale()) {
          this.setState({
            csvParsing: false,
            csvValidating: false,
            csvValidationResults: { valid: [], invalid: invalidFormatEmails, duplicates: [] },
            showCsvResults: invalidFormatEmails.length > 0
          });
        }
        return;
      }

      if (this._isMounted && !isValidationStale()) {
        this.setState({ csvParsing: false, csvValidating: true, csvValidationProgress: { current: 0, total: validFormatEmails.length } });
      }

      // Validate against API
      const apiResults = await this._validateEmailsAgainstApi(validFormatEmails, currentValidationId);
      if (isValidationStale()) return;

      // Check for duplicates (already in autocomplete selection)
      const existingIds = new Set((this.state.user || []).map(u => u.id));
      const duplicates = [];
      const valid = [];

      apiResults.valid.forEach(user => {
        if (existingIds.has(user.id)) {
          duplicates.push(user);
        } else {
          valid.push(user);
        }
      });

      if (this._isMounted && !isValidationStale()) {
        this.setState({
          csvValidating: false,
          csvValidationResults: {
            valid,
            invalid: [...invalidFormatEmails, ...apiResults.invalid],
            duplicates
          },
          showCsvResults: true
        });
      }
    } catch (error) {
      if (this._isMounted && !isValidationStale()) {
        const isNetworkError = error.message === 'Network error during validation';
        this.setState({
          csvParsing: false,
          csvValidating: false,
          csvError: isNetworkError
            ? 'Network error during validation. Please try again.'
            : 'Failed to process CSV file. Please try again.'
        });
      }
    }
  }

  async _validateEmailsAgainstApi(emails, currentValidationId) {
    const valid = [];
    const invalid = [];
    const batchSize = 25;

    // Helper to check if this validation is still current
    const isValidationStale = () => this._csvValidationId !== currentValidationId;

    for (let i = 0; i < emails.length; i += batchSize) {
      // Check if validation was cancelled (modal closed or new upload started)
      if (isValidationStale()) {
        return { valid, invalid };
      }

      const batch = emails.slice(i, i + batchSize);

      const results = await Promise.allSettled(
        batch.map(async (email) => {
          const response = await apiClient().get('/admins/users', {
            params: { email, per_page: 1 }
          });
          const users = response.data?.data?.data || [];
          // Using exact match via email param - first result is the match (if any)
          return { email, user: users[0] };
        })
      );

      // Check for any network failures
      const hasFailure = results.some(r => r.status === 'rejected');
      if (hasFailure) {
        throw new Error('Network error during validation');
      }

      results.forEach((result) => {
        if (result.status === 'fulfilled' && result.value.user) {
          valid.push({
            id: result.value.user.id,
            email: result.value.user.email
          });
        } else if (result.status === 'fulfilled') {
          invalid.push({
            email: result.value.email,
            reason: 'User not found in system'
          });
        }
      });

      // Update progress only if validation is still current
      if (this._isMounted && !isValidationStale()) {
        this.setState({
          csvValidationProgress: { current: Math.min(i + batchSize, emails.length), total: emails.length }
        });
      }
    }

    return { valid, invalid };
  }

  _confirmAddValidUsers() {
    const { csvValidationResults, user } = this.state;
    if (!csvValidationResults || csvValidationResults.valid.length === 0) return;

    // Re-check for duplicates at merge time (user may have manually added users while results showing)
    const existingIds = new Set((user || []).map(u => u.id));
    const usersToAdd = csvValidationResults.valid.filter(u => !existingIds.has(u.id));

    if (usersToAdd.length === 0) {
      // All users were already added manually
      this.setState({
        csvValidationResults: null,
        showCsvResults: false,
        csvSuccessMessage: 'All users were already selected'
      });
    } else {
      const newUsers = [...(user || []), ...usersToAdd];
      this.setState({
        user: newUsers,
        csvValidationResults: null,
        showCsvResults: false,
        csvSuccessMessage: `Added ${usersToAdd.length} user${usersToAdd.length > 1 ? 's' : ''} from CSV`
      });
    }

    // Clear existing timer before scheduling new one (prevents early dismissal)
    if (this.successMessageTimer) {
      clearTimeout(this.successMessageTimer);
      this.successMessageTimer = null;
    }

    // Auto-dismiss success message after 3 seconds
    this.successMessageTimer = setTimeout(() => {
      if (this._isMounted) {
        this.setState({ csvSuccessMessage: null });
        this.successMessageTimer = null;
      }
    }, 3000);
  }

  _clearCsvResults() {
    this.setState({
      csvValidationResults: null,
      showCsvResults: false,
      csvError: null
    });
  }

  _validateForm(){
    let errors={};
    if(this.state.user.length==0)
      errors['user']=['The user field is required..'];
    if(Object.keys(errors).length){
      this.setState({
        error:{errors:{...errors}, status_code:422,message:'Please fulfill your form *'}
      })
    }
    return errors;
  }

  onSubmit(e){
    e.preventDefault();
    const valid= this._validateForm();
    let getUser = this.state.user;
    if(this.state.id==null)
      getUser = this.state.user.map(user =>user.id);
    if(Object.keys(valid).length===0){
      let payload = {
        id:this.state.id,
        used:this.state.used,
        used_count:this.state.used_count,
        used_at:this.state.used_at,
        voucher_id: this.state.voucher_id,
        user_id:this.state.id?this.state.user.id:getUser,
        quantity:this.state.quantity,
        started_at: this.state.started_at,
        ended_at: this.state.ended_at
      }
      this.setState({
        isSubmit:true,
        error:null,
      },()=>{
        this.props.onSubmit(payload);
      });
    }
  }

  _renderError(){
    const { error, isAlertError } = this.state;
    if(error!==null){
      switch(error.status_code){
        case 422:
          return <Alert color="danger" isOpen={isAlertError} toggle={this.onDismiss}>Please fulfill your form</Alert>
        default:
          return <Alert color="danger" isOpen={isAlertError} toggle={this.onDismiss}>Houston, we have a problem!. Please inform our friendly staff via LINE @kickavenue</Alert>
      }
    }
    return null;
  }

  render(){
    return(        
      <Modal isOpen={this.props.isOpen} toggle={this.props.onCancel} className="modal-dialog modal-md">
        <ModalHeader toggle={this.props.onCancel}>{this.state.id === null? 'Add ': ''}User Voucher</ModalHeader>
        <ModalBody>
        <Form>
          <Row>
            <Col  xs={12} md={8}>
              <FormGroup  className={classnames({'has-danger has-feedback':hasError('user',this.state.error)})}>
                <Label for="formUser">
                  User*
                  {this.state.id === null && (
                    <button
                      type="button"
                      style={CSV_BTN_STYLE}
                      aria-label="Upload CSV (one email per line)"
                      onClick={this._triggerCsvInput}
                      disabled={this.state.csvParsing || this.state.csvValidating}
                    >
                      <i className="fa fa-upload" />
                    </button>
                  )}
                </Label>
                <input
                  type="file"
                  accept=".csv"
                  ref={this.csvInputRef}
                  style={HIDDEN_INPUT_STYLE}
                  onChange={this._handleCsvFileChange}
                />
                <SelectUserAsync
                  isMulti
                  defaultOptions
                  id="_formSelectUser"
                  userId={this.props.dataAuth.id}
                  ref="selectUser"
                  value={this.state.user}
                  paramsApi={{ roles: 'user,seller,administrator', role_query: 'or', scope: 'all' }}
                  placeholder="Type and select a user..."
                  noResultsText="Cannot find user."
                  loadOptions={this._getUserOptions}
                  onSelectSearch={(input)=>this.setState({_recentUserSearch: input})}
                  onSelectChange={this._handleOnSelectUserChange}
                  onSelectOpen={this._handleOnSelectUserOpen}
                  isDisabled={this.state.id?true:false}
                />
                {errorMessage('user',this.state.error)}

                {/* CSV Parsing/Validating Progress */}
                {(this.state.csvParsing || this.state.csvValidating) && (
                  <div className="mt-2">
                    {this.state.csvParsing && <small>Parsing CSV...</small>}
                    {this.state.csvValidating && (
                      <Progress value={this.state.csvValidationProgress.total > 0
                        ? (this.state.csvValidationProgress.current / this.state.csvValidationProgress.total) * 100
                        : 0}>
                        Checking {this.state.csvValidationProgress.current}/{this.state.csvValidationProgress.total} emails...
                      </Progress>
                    )}
                  </div>
                )}

                {/* CSV Validation Results */}
                {this.state.showCsvResults && this.state.csvValidationResults && (
                  <Alert color="info" className="mt-2">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <strong>CSV Validation Results:</strong><br/>
                        <span className="text-success">{this.state.csvValidationResults.valid.length} valid</span>
                        {this.state.csvValidationResults.invalid.length > 0 && (
                          <span className="text-danger">, {this.state.csvValidationResults.invalid.length} invalid</span>
                        )}
                        {this.state.csvValidationResults.duplicates.length > 0 && (
                          <span style={WARNING_TEXT_STYLE}>, {this.state.csvValidationResults.duplicates.length} already selected</span>
                        )}
                      </div>
                      <div>
                        {this.state.csvValidationResults.valid.length > 0 && (
                          <Button color="primary" size="sm" onClick={this._confirmAddValidUsers} className="mr-1">
                            Add {this.state.csvValidationResults.valid.length} Valid Users
                          </Button>
                        )}
                        <Button color="secondary" size="sm" onClick={this._clearCsvResults}>Cancel</Button>
                      </div>
                    </div>

                    {/* Duplicates (yellow) */}
                    {this.state.csvValidationResults.duplicates.length > 0 && (
                      <div className="mt-2" style={DUPLICATES_BOX_STYLE}>
                        <small><strong>Already selected:</strong></small>
                        <ul className="mb-0 pl-3" style={SMALL_TEXT_STYLE}>
                          {this.state.csvValidationResults.duplicates.map((item) => (
                            <li key={item.email}>{item.email}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Invalid emails */}
                    {this.state.csvValidationResults.invalid.length > 0 && (
                      <div className="mt-2" style={SCROLLABLE_LIST_STYLE}>
                        <small><strong>Invalid emails:</strong></small>
                        <ul className="mb-0 pl-3" style={SMALL_TEXT_STYLE}>
                          {this.state.csvValidationResults.invalid.map((item, idx) => (
                            <li key={`${item.email}-${idx}`}>{item.email} - {item.reason}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Alert>
                )}

                {/* CSV Success Message */}
                {this.state.csvSuccessMessage && (
                  <Alert color="success" className="mt-2">{this.state.csvSuccessMessage}</Alert>
                )}

                {/* CSV Error Message */}
                {this.state.csvError && (
                  <Alert color="danger" className="mt-2" toggle={() => this.setState({ csvError: null })}>
                    {this.state.csvError}
                  </Alert>
                )}
              </FormGroup>
            </Col>
            <Col xs={4}>
              <FormGroup className={classnames({'has-danger has-feedback':hasError('quantity',this.state.error)})}>
                <Label for="formQuantity">Quantity</Label>
                <Input
                  type="number"
                  id="formQuantiy"
                  name="quantity"
                  placeholder="Enter a quantity usage*"
                  value={textValue('quantity',this.state)}
                  onChange={this.handleChange}
                  disabled={this.state.id?true:false}
                />
                {errorMessage('quantity',this.state.error)}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6}>
              <FormGroup  className={classnames({'has-danger has-feedback':hasError('started_at',this.state.error)})}>
                <Label for="formDeliverSentDate">Start Date</Label>
                <InputDatetime 
                  name="started_at"
                  id="formStartedDate"
                  timeFormat="HH:mm"
                  value={dateValue('started_at',this.state)}
                  onChange={(date)=>this.handleDatePickerChange(date,'started_at')}
                  inputProps={{placeholder:'Pick a Started At', id:'formStartedDate'}}
                />
                {errorMessage('started_at',this.state.error)}
              </FormGroup>
            </Col>
            <Col xs={12} md={6}>
              <FormGroup  className={classnames({'has-danger has-feedback':hasError('ended_at',this.state.error)})}>
                <Label for="formDeliverSentDate">End Date</Label>
                <InputDatetime 
                  name="ended_at"
                  id="formEndedDate"
                  timeFormat="HH:mm"
                  value={dateValue('ended_at',this.state)}
                  onChange={(date)=>this.handleDatePickerChange(date,'ended_at')}
                  inputProps={{placeholder:'Pick a Ended At', id:'formEndedDate'}}
                />
                {errorMessage('ended_at',this.state.error)}
              </FormGroup>
            </Col>
          </Row>
          {
            this.state.id!==null?
            <Row>
              <Col xs={12} md={6}>
                <FormGroup  className={classnames({'has-danger has-feedback':hasError('used_count',this.state.error)})}>
                  <Label for="formUsedCount">Used Count</Label>
                  <Input
                    type="number"
                    id="formUsedCount"
                    name="used_count"
                    placeholder="Used Count"
                    value={textValue('used_count',this.state)}
                    onChange={this.handleChange}
                  />
                  {errorMessage('used_count',this.state.error)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup  className={classnames({'has-danger has-feedback':hasError('used_at',this.state.error)})}>
                  <Label for="formDeliverSentDate">Used Date</Label>
                  <InputDatetime 
                    name="used_at"
                    id="formUsedDate"
                    timeFormat="HH:mm"
                    value={dateValue('used_at',this.state)}
                    onChange={(date)=>this.handleDatePickerChange(date,'used_at')}
                    inputProps={{placeholder:'Pick a Used At', id:'formUsedDate'}}
                  />
                  {errorMessage('used_at',this.state.error)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup className={classnames({'has-danger has-feedback':hasError('Used',this.state.error)})}>
                  <Label for="formUsed">Used &nbsp;</Label>
                  <Radio
                    name="used"
                    id="formUsed"
                    value="true" checked={textValue('used', this.state)}
                    onChange={this.handleCheckedChange}
                  />
                  {errorMessage('used',this.state.error)}
                </FormGroup>
              </Col>
            </Row>
            :
            null
          }            
        </Form>
        <span className="text-sm">Fields marked with * are required</span><br/>
        <span className="text-sm">Notes when you not pass Start Date & End Date by default 3 month</span>
        <span>{this._renderError()}</span>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" disabled={this.state.isSubmit} onClick={this.onSubmit}>{this.state.isSubmit?'Submitting...':'Submit'}</Button>{' '}
          <Button color="secondary" onClick={this.props.onCancel}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}
ModalUserVoucher.propTypes={
  dataUserVouchers: PropTypes.object,
  dataAuth: PropTypes.object,
  userVoucherSelected: PropTypes.object,
  onGetUserVoucherList: PropTypes.func.isRequired,
  onRemoveSelected: PropTypes.func.isRequired,
  voucherId:PropTypes.number.isRequired,
  isOpen:PropTypes.bool,
  onSubmit:PropTypes.func,
  onCancel:PropTypes.func
}